import { Get, Post } from "./api";
import { hasFeature } from "../lib/features";

/**
 * Arqueo y cierre de caja.
 *
 * Cerrar una caja es un acto contable: el backend exige el efectivo contado
 * (POST /registers/{id}/close) y a partir de ahí la caja es el acta del turno,
 * inmutable. El endpoint antiguo POST /registers no cierra nada: abre una caja
 * nueva, por eso no sirve para el cierre.
 *
 * Estas rutas están tras el feature `contabilidad_arqueo_caja`. Sin ese feature
 * el backend responde 403 con `error_code: "feature_required"`.
 */

/** La caja abierta del ejercicio, o null si no hay ninguna. */
export async function getOpenRegister({ shopId, exerciseId }) {
  const registers = await Get({
    request: `/registers?shop_id=${shopId}&exercise_id=${exerciseId}`,
  });

  if (!Array.isArray(registers)) return null;

  return registers.find((register) => register.open) || null;
}

/**
 * Qué debería haber en el cajón ahora mismo, sin cerrar nada. Es lo que se
 * muestra para que el conteo sea una comparación y no un acto a ciegas.
 */
export function getRegisterArqueo(registerId, shopId) {
  return Get({ request: `/registers/${registerId}/arqueo?shop_id=${shopId}` });
}

/**
 * Cierra la caja con el efectivo contado. El backend guarda el arqueo, calcula
 * la diferencia y la refleja en tesorería si se le pasa la cuenta.
 *
 * Ojo: `api.js` no lanza excepción ante un 4xx, devuelve el cuerpo del error.
 * Hay que mirar `result.error` antes de dar el cierre por bueno.
 */
export function closeRegister(registerId, shopId, data) {
  return Post({
    request: `/registers/${registerId}/close`,
    data: { ...data, shop_id: shopId },
  });
}

/**
 * Si la tienda puede cerrar caja con arqueo.
 *
 * Se pregunta por el feature, que es lo que exige el backend, y no por el
 * pack `contabilidad`: el acceso puede venir de cualquier pack que incluya el
 * grupo `contabilidad` (el propio, el interno `completo` o uno de un reseller).
 */
export function canCloseRegister(user) {
  return hasFeature(user, "contabilidad_arqueo_caja");
}
